package com.evoapps.evoshift.data.dto.roster

import kotlinx.serialization.Serializable

@Serializable
data class AvailabilityDto(
    val userId: String,
    val rosterId: String? = null,
    val workplaceId: String? = null,
    val month: String,
    val isLocked: Boolean,
    val isFilled: Boolean = false,
    val days: Map<String, AvailabilityDayDto> = emptyMap(),
    /** SH-173: "EMAIL_LINK" when given through the e-mailed link (written by the functions). */
    val source: String? = null
)

@Serializable
data class AvailabilityDayDto(
    val status: AvailabilityStatusDto,
    val prefSlotId: String? = null,
    val comment: String? = null,
    /** SH-135: the person's hours behind this day (empty: the whole day), for display. */
    val hours: List<HoursRangeDto> = emptyList()
)

/** SH-135: "HH:MM"-"HH:MM". */
@Serializable
data class HoursRangeDto(val start: String, val end: String)

/** SH-135: one day of `users/{uid}/availability/{YYYY-MM}`. */
@Serializable
data class SharedAvailabilityDayDto(
    val status: AvailabilityStatusDto,
    val ranges: List<HoursRangeDto> = emptyList(),
    val preferred: List<HoursRangeDto> = emptyList(),
    val comment: String? = null,
    val workplaceComments: Map<String, String> = emptyMap()
)

/** SH-135: `users/{uid}/availability/{YYYY-MM}`: the person's month for all their workplaces. */
@Serializable
data class SharedAvailabilityDto(
    val userId: String,
    val month: String,
    val isFilled: Boolean = false,
    val releasedToOwnerIds: List<String> = emptyList(),
    val updatedAt: String? = null,
    val days: Map<String, SharedAvailabilityDayDto> = emptyMap()
)

/** SH-135: `users/{uid}/settings/availability`. */
@Serializable
data class AvailabilitySharingDto(
    val shareWithAllEmployers: Boolean? = null,
    val updatedAt: String? = null
)

@Serializable
enum class AvailabilityStatusDto {
    AVAILABLE,
    UNAVAILABLE
}

@Serializable
data class AvailabilityRequestDto(
    val id: String,
    val workplaceId: String,
    val rosterId: String,
    val month: String,
    val period: AvailabilityPeriodDto,
    val dueDate: String,
    val sentAt: String,
    val createdBy: String,
    val message: String? = null,
    /** SH-173: "NO_APP" | "ALL": also by e-mail with a link to the web form (functions/availabilityLinks.js). */
    val emailLinks: String? = null
)

@Serializable
data class AvailabilityPeriodDto(
    val startDate: String,
    val endDate: String
)

@Serializable
data class WeeklyAvailabilityTemplateDto(
    val id: String,
    val name: String,
    val userId: String,
    val workplaceId: String,
    val days: Map<String, AvailabilityDayDto> = emptyMap()
)
